import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {
    setPrimerPosPrintVoucherPosition,
    setPrimerPosRequestData,
    setPrimerPosResponseData, setSelectedPrimerPos
} from "../../../../_reducers/DataPanel/Clients/clientSlice";
import axios from "axios";
import {toast} from "react-toastify";
import PrimerPosModal from "./primer-pos-modals/primer-pos-modal";
import ReportsTemplate from "../../../common/ReportsTemplate";
import {Badge, Button, Col, Row, Table} from "react-bootstrap";
import DateBox from "../../../primer/DateBox";
import {isEmpty} from "../../../../_helpers/commonFunctions";
import moment from "moment/moment";
import Input from "../../../common/Input";
import Dropdown from "../../../primer/Dropdown";
import InsertPosModal from "./primer-pos-modals/insert-pos-modal";
import BootstrapDropdown from "react-bootstrap/Dropdown";
import {jsPDF} from "jspdf";
import {liberationSerif} from "../../../../fonts/liberationSerif";
import {dejavuSans} from "../../../../fonts/DejaVuSans-normal";
import {dejavuSansBold} from "../../../../fonts/DejaVuSans-Bold-bold";
import {autoTable} from "jspdf-autotable";
import * as XLSX from "xlsx";
import Alert from "react-bootstrap/Alert";
import {CgDanger} from "react-icons/cg";
import {useTranslation} from "../../../../hooks/useTranslation";

const PrimerPosReport = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const requestData = useSelector((state) => state.CLIENTS_DATA.primerPosRequestData);
    const responseData = useSelector((state) => state.CLIENTS_DATA.primerPosResponseData);
    const selectedPos = useSelector((state) => state.CLIENTS_DATA.selectedPrimerPos);
    const apiLoginURL = process.env.REACT_APP_LOGIN_URL;

    const [pageChanged, setPageChanged] = useState(false);
    const [loading, setLoading] = useState(false);
    const [insertNewModal, setInsertNewModal] = useState(false);
    const [subscriptionNames, setSubscriptionNames] = useState([]);

    const statusOptions = [
        {value: "notAvailable", label: "Μη Διαθέσιμο", color: "#ffcfcf"},
        {value: "waitingStock", label: "Αναμένεται Συσκευή", color: "#ffcfcf"},
        {value: "available", label: "Διαθέσιμο", color: "#fff5bd"},
        {value: "purchased", label: "Δεσμευμένο", color: "#e3b7eb"},
        {value: "ready", label: "Προς αποστολή", color: "#b8cfff"},
        {value: "shipped", label: "Απεσταλμένο", color: "#b1fcb1"},
        {value: "arrived", label: "Παρελήφθη", color: "#b1fcb1"}
    ];

    const contractStatusOptions = [
        {value: "noIssue", label: "Δεν έχει εκδοθεί"},
        {value: "issue", label: "Αναμένεται υπογραφή"},
        {value: "signed", label: "Υπεγράφη"},
    ];

    const subscriptionStatusOptions = [
        {value: "active", label: "Ενεργή"},
        {value: "canceled", label: "Ακυρωμένη"},
        {value: "pending", label: "Εκκρεμεί πληρωμή"},
    ];
    const configurationStatusOptions = [
        {value: "completed", label: "Πλήρως Παραμετροποιημένο"},
        {value: "semiCompleted", label: "Μερικώς Παραμετροποιημένο"},
        {value: "notStarted", label: "Μη Παραμετροποιημένο"},
    ];

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchReport(true);
        }
    }, [pageChanged])

    useEffect(() => {
        if(!selectedPos && responseData?.data?.length > 0){
            fetchReport(true);
        }
    }, [selectedPos]);

    useEffect(() => {
        getSubscriptionNames();
    }, []);

    useEffect(() => {
        if(requestData?.remote) {
            fetchReport(false);
        }
    }, [requestData?.remote]);

    const syncPos = () => {
        setLoading(true);
        const reqData = {company: company.id};
        axios.post(`${process.env.REACT_APP_API_URL2}/client/primer-pos-sync`, reqData, {
            headers: { 'Content-Type': 'application/json' },
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                toast.success("Επιτυχής Συγχρονισμός");
                fetchReport();
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const fetchReport = (fromPagination = false) => {
        setLoading(true);
        let reqData = {...requestData, company: company.id}
        if (!fromPagination) {
            reqData.page = 1;
            dispatch(setPrimerPosRequestData({...requestData, page: 1, remote: false}));
        }
        axios.post(`${process.env.REACT_APP_API_URL2}/client/primer-pos-report`, reqData, {
            headers: { 'Content-Type': 'application/json' },
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                dispatch(setPrimerPosPrintVoucherPosition(res.data?.printVoucherPosition || 1));
                if (res.data?.data?.data?.length === 0) {
                    toast.info("Δεν βρέθηκαν δεδομένα.");
                } else {
                    if (!fromPagination) {
                        toast.success("Τα δεδομένα ανανεώθηκαν", {autoClose: 1000});
                    }
                }
                let cloneData = structuredClone(res.data.data?.data || []);
                cloneData.forEach((obj, i) => {
                    obj.no = 20 * Number(res.data.data.currentPage - 1) + i + 1;
                })
                dispatch(setPrimerPosResponseData({...responseData, data: cloneData, totalPages: res.data?.data?.totalPages, totalItems: res.data?.data?.totalItems, totals: res.data?.totals }));
            } else {
                dispatch(setPrimerPosResponseData({data: [], totalPages: 0, totalItems: 0, totals: []}));
                toast.error(res.data.message);
            }
        }).catch((err) => {
            dispatch(setPrimerPosResponseData({data: [], totalPages: 0, totalItems: 0,totals: []}));
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const toFirstPage = () => {
        dispatch(setPrimerPosRequestData({...requestData, page: 1}));
        setPageChanged(true);
    }
    const toPreviousPage = () => {
        dispatch(setPrimerPosRequestData({...requestData, page: requestData.page - 1}));
        setPageChanged(true);
    }
    const toNextPage = () => {
        dispatch(setPrimerPosRequestData({...requestData, page: requestData.page + 1}));
        setPageChanged(true);
    }
    const toLastPage = () => {
        dispatch(setPrimerPosRequestData({...requestData, page: responseData.totalPages}));
        setPageChanged(true);
    }

    const handleOnChange = (e, type, name) => {
        if (type === "datebox") {
            if (moment(e).isValid()) {
                dispatch(setPrimerPosRequestData({...requestData, [name] : moment(e).format("DD/MM/YYYY")}));
            } else {
                dispatch(setPrimerPosRequestData({...requestData, [name] : ""}));
            }
        } else if (type === "checkbox") {
            dispatch(setPrimerPosRequestData({...requestData, [name] : e.target.checked}));
        } else if (type === "dropdown") {
            if(name === "subscriptions") {
                dispatch(setPrimerPosRequestData({...requestData, subscriptions: e}));
            } else if (name === "status") {
                dispatch(setPrimerPosRequestData({...requestData, status: e}));
            } else if(name === "contractStatus") {
                dispatch(setPrimerPosRequestData({...requestData, contractStatus: e}));
            } else if(name === "subscriptionStatus") {
                dispatch(setPrimerPosRequestData({...requestData, subscriptionStatus: e}));
            } else if(name === "configurationStatus") {
                dispatch(setPrimerPosRequestData({...requestData, configurationStatus: e}));
            } else {
                dispatch(setPrimerPosRequestData({...requestData, [name] : e.value}));
            }
        } else if(type === "input") {
            dispatch(setPrimerPosRequestData({...requestData, [name] : e.target.value}));
        }
    }

    const getSubscriptionNames = () => {
        axios.get(process.env.REACT_APP_API_URL2 + `/settings/get-subscription-names`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: company.id,
                user: JSON.parse(localStorage.getItem("user"))._id,
                showOnlyPos: "true"
            }
        }).then((res) => {
            if (res.data.status === "401") {
                localStorage.clear();
                window.location.replace(`${apiLoginURL}?redirect=ERP&error=You are not Authorized!`);
            } else if (res.data.status === "200") {
                let finalData = [];
                if(res.data.data && res.data.data?.length > 0) {
                    res.data.data.forEach((sub) => {
                        finalData.push({
                            label: sub.name,
                            value: sub.id,
                        })
                    })
                }
                setSubscriptionNames(finalData);
            }
        }).catch((err) => {
            console.log(err);
        })
    }


    const handlePDFExport = async () => {
        try {
            const apiResponse = await axios.post(process.env.REACT_APP_API_URL2 + `/client/primer-pos-report`,
                {...requestData, company: company.id, page: -1},
                {headers: { "Content-Type": "application/json" }});
            if (apiResponse.data.status === "200") {
                let rows = [];
                const headerColumns = ["A/A", "Σειριακός Αριθμός", "Θέση Αποθήκης", "Ημερομηνία Εισαγωγής", "Πελάτης", "Συσκευή", "Κατάσταση", "Κατάσταση Συμβολαίου", "Κατάσταση Παραμετροποίησης", "Ημερομηνία Αγοράς", "Ημερομηνία Αποστολής", "Κατάσταση Αποστολής"];
                let incrementNo = 1;
                for (let d of apiResponse.data.data.data) {
                    let configurationStatus = "";
                    if(d["configurationSteps"].length > 0) {
                        if(d["configurationSteps"].every((el) => el.status === "completed")) {
                            configurationStatus = `Πλήρως Παραμετροποιημένο (${d["configurationSteps"].filter((el) => el.status === "completed")?.length} / ${d["configurationSteps"]?.length})`
                        } else if(d["configurationSteps"].some((el) => el.status === "completed")) {
                            configurationStatus = `Μερικώς Παραμετροποιημένο (${d["configurationSteps"].filter((el) => el.status === "completed")?.length} / ${d["configurationSteps"]?.length})`
                        } else {
                            configurationStatus = `Μη Παραμετροποιημένο (${d["configurationSteps"].filter((el) => el.status === "completed")?.length} / ${d["configurationSteps"]?.length})`
                        }
                    }
                    rows.push([
                        incrementNo,
                        d.serialNumber,
                        d.warehousePosition,
                        moment(d["created_at"]).format("DD/MM/YYYY"),
                        d["clientVatNumber"] ? `${d["clientVatNumber"]} (${d["clientName"]})` : "",
                        d["productName"],
                        statusOptions.find((el) => el.value === d["status"])?.label,
                        contractStatusOptions.find((el) => el.value === d["contractStatus"])?.label,
                        configurationStatus,
                        d["paidDate"] ? moment(d["paidDate"]).format("DD/MM/YYYY HH:mm") : "",
                        d["shippingDate"] ? moment(d["shippingDate"]).format("DD/MM/YYYY") : "",
                        (!isEmpty(d["acsTrackingDetails"]) && d["acsTrackingDetails"]?.length > 0)? d["acsTrackingDetails"].slice().sort((a, b) => new Date(b.checkpoint_date_time) - new Date(a.checkpoint_date_time))[0]?.checkpoint_action : ""
                        ])
                    incrementNo ++;
                }
               // rows.push(["", "", "", "", "", "", "ΣΥΝΟΛΟ", getGreekCurrencyFormat(apiResponse.data.data.totalNetValue)]);

                const doc = new jsPDF('landscape');
                let y = 20;
                doc.addFileToVFS("arialuni.ttf", liberationSerif);
                doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
                doc.addFileToVFS("dejavusans.ttf", dejavuSans);
                doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
                doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
                doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");
                doc.setFont("DejaVu Sans Bold");
                doc.setFontSize(10);
                const header = doc.splitTextToSize(`Συσκευές POS`, 200);
                const headerString = header.join("\n");
                doc.text(headerString, doc.internal.pageSize.getWidth() / 4, 9, {alignment: "center"});
                doc.setFont("DejaVu Sans Normal");
                const imgData = 'assets/images/prrimer-logo.png';
                const imgX = doc.internal.pageSize.getWidth() - 45; // adjust the position as needed
                const imgY = 3; // adjust the position as needed
                doc.addImage(imgData, 'PNG', imgX, imgY, 40, 15);
                doc.setFont("DejaVu Sans Normal");
                autoTable(doc, {
                    startY: y,
                    head: [headerColumns],
                    body: rows,
                    rowPageBreak: "avoid",
                    styles: {
                        font: "DejaVu Sans Normal",
                        fontStyle: "normal",
                        fontSize: 8, // set font size
                        halign: "center", // set alignment
                    },
                })
                const pageCount = doc.getNumberOfPages();
                // Add the pagination to each page
                for (let i = 1; i <= pageCount; i++) {
                    doc.setPage(i);
                    doc.setFontSize(10);
                    doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
                }
                doc.save("Συσκευές POS.pdf");
            } else {
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            }
        } catch (error) {
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            console.log(error);
        }
    }

    const handleExcelExport = async () => {
        try {
            const apiResponse = await axios.post(process.env.REACT_APP_API_URL2 + `/client/primer-pos-report`,
                {...requestData, company: company.id, page: -1},
                {headers: { "Content-Type": "application/json" }});
            if (apiResponse.data.status === "200") {
                let rows = [];
                const headerColumns = ["A/A", "Σειριακός Αριθμός", "Θέση Αποθήκης", "Ημερομηνία Εισαγωγής", "Πελάτης", "Συσκευή", "Κατάσταση", "Κατάσταση Συμβολαίου", "Κατάσταση Παραμετροποίησης", "Ημερομηνία Αγοράς", "Ημερομηνία Αποστολής", "Κατάσταση Αποστολής"];
                rows.push(headerColumns);
                let incrementNo = 1;
                for (let d of apiResponse.data.data.data) {
                    let configurationStatus = "";
                    if(d["configurationSteps"].length > 0) {
                        if(d["configurationSteps"].every((el) => el.status === "completed")) {
                            configurationStatus = `Πλήρως Παραμετροποιημένο (${d["configurationSteps"].filter((el) => el.status === "completed")?.length} / ${d["configurationSteps"]?.length})`
                        } else if(d["configurationSteps"].some((el) => el.status === "completed")) {
                            configurationStatus = `Μερικώς Παραμετροποιημένο (${d["configurationSteps"].filter((el) => el.status === "completed")?.length} / ${d["configurationSteps"]?.length})`
                        } else {
                            configurationStatus = `Μη Παραμετροποιημένο (${d["configurationSteps"].filter((el) => el.status === "completed")?.length} / ${d["configurationSteps"]?.length})`
                        }
                    }
                    rows.push([
                        incrementNo,
                        d.serialNumber,
                        d.warehousePosition,
                        moment(d["created_at"]).format("DD/MM/YYYY"),
                        d["clientVatNumber"] ? `${d["clientVatNumber"]} (${d["clientName"]})` : "",
                        d["productName"],
                        statusOptions.find((el) => el.value === d["status"])?.label,
                        contractStatusOptions.find((el) => el.value === d["contractStatus"])?.label,
                        configurationStatus,
                        d["paidDate"] ? moment(d["paidDate"]).format("DD/MM/YYYY HH:mm") : "",
                        d["shippingDate"] ? moment(d["shippingDate"]).format("DD/MM/YYYY") : "",
                        (!isEmpty(d["acsTrackingDetails"]) && d["acsTrackingDetails"]?.length > 0)? d["acsTrackingDetails"].slice().sort((a, b) => new Date(b.checkpoint_date_time) - new Date(a.checkpoint_date_time))[0]?.checkpoint_action : ""
                    ])
                    incrementNo ++;
                }
                const workSheet = XLSX.utils.aoa_to_sheet(rows);
                const workBook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workBook, workSheet, "Συσκευές POS");
                XLSX.writeFile(workBook, 'Συσκευές POS.xlsx');
            } else {
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            }
        } catch (err) {
            setLoading(false);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            console.log(err);
        }
    }




    return (
        <React.Fragment>
            <ReportsTemplate templateType={"reports-primer-pos"} requestData={requestData} fetchReport={() => fetchReport()} setRequestData={(data) => dispatch(setPrimerPosRequestData(data))} header={"Διαχείριση POS"} />
            <Row onKeyDown={(e) => {
                if (e.key === "Enter") fetchReport(false)}
            }>
            <Row className={"mb-2"}>
                <Col md={2}>
                    <DateBox
                        name="date_from"
                        allowOtherYears={true}
                        selected={isEmpty(requestData.date_from) ? "" : moment(requestData.date_from, "DD/MM/YYYY").toDate()}
                        label={"Ημερομηνία Εισαγωγής Από:"}
                        onChange={(e) => handleOnChange(e, "datebox", "date_from")}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        name="date_to"
                        allowOtherYears={true}
                        selected={isEmpty(requestData.date_to) ? "" : moment(requestData.date_to, "DD/MM/YYYY").toDate()}
                        label={"Ημερομηνία Εισαγωγής Μέχρι:"}
                        onChange={(e) => handleOnChange(e, "datebox", "date_to")}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        name="subscription_date_from"
                        allowOtherYears={true}
                        selected={isEmpty(requestData.subscription_date_from) ? "" : moment(requestData.subscription_date_from, "DD/MM/YYYY").toDate()}
                        label={"Ημερομηνία Αγοράς Από:"}
                        onChange={(e) => handleOnChange(e, "datebox", "subscription_date_from")}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        name="subscription_date_to"
                        allowOtherYears={true}
                        selected={isEmpty(requestData.subscription_date_to) ? "" : moment(requestData.subscription_date_to, "DD/MM/YYYY").toDate()}
                        label={"Ημερομηνία Αγοράς Μέχρι:"}
                        onChange={(e) => handleOnChange(e, "datebox", "subscription_date_to")}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        name="shipping_date_from"
                        allowOtherYears={true}
                        selected={isEmpty(requestData.shipping_date_from) ? "" : moment(requestData.shipping_date_from, "DD/MM/YYYY").toDate()}
                        label={"Ημερομηνία Αποστολής Από:"}
                        onChange={(e) => handleOnChange(e, "datebox", "shipping_date_from")}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        name="shipping_date_to"
                        allowOtherYears={true}
                        selected={isEmpty(requestData.shipping_date_to) ? "" : moment(requestData.shipping_date_to, "DD/MM/YYYY").toDate()}
                        label={"Ημερομηνία Αποστολής Μέχρι:"}
                        onChange={(e) => handleOnChange(e, "datebox", "shipping_date_to")}
                    />
                </Col>
            </Row>
            <Row className={"mb-2"}>
                <Col md={4}>
                    <Input
                        name="client"
                        label="Όνομα/ΑΦΜ Πελάτη"
                        autoComplete="off"
                        value={requestData.client}
                        onChange={(e) => handleOnChange(e, "input", "client")}
                    />
                </Col>
                <Col md={2}>
                    <Input
                        name="serialNumber"
                        label="Σειριακός Αριθμός Συσκευής"
                        autoComplete="off"
                        value={requestData.serialNumber}
                        onChange={(e) => handleOnChange(e, "input", "serialNumber")}
                    />
                </Col>
                <Col md={2}>
                    <Input
                        name="acsVoucher"
                        label="ACS Voucher"
                        autoComplete="off"
                        value={requestData.acsVoucher}
                        onChange={(e) => handleOnChange(e, "input", "acsVoucher")}
                    />
                </Col>
                <Col md={2}>
                    <Input
                        name="simId"
                        label="Αριθμός SIM"
                        autoComplete="off"
                        value={requestData.simId}
                        onChange={(e) => handleOnChange(e, "input", "simId")}
                    />
                </Col>
                <Col md={2}>
                    <Input
                        name="warehousePosition"
                        label="Θέση Αποθήκης"
                        autoComplete="off"
                        value={requestData.warehousePosition}
                        onChange={(e) => handleOnChange(e, "input", "warehousePosition")}
                    />
                </Col>
            </Row>
            <Row className={"mb-2"}>
                <Col md={2}>
                    <Input
                        name="subscriptionId"
                        label="Αριθμός Συνδρομής / Παραγγελίας"
                        autoComplete="off"
                        value={requestData.subscriptionId}
                        onChange={(e) => handleOnChange(e, "input", "subscriptionId")}
                    />
                </Col>
                <Col md={2}>
                    <Dropdown
                        name="subscriptions"
                        label="Τύποι Συσκευών"
                        multiSelect={true}
                        options={subscriptionNames}
                        defaultValue={requestData.subscriptions}
                        onChange={(e) => handleOnChange(e, "dropdown", "subscriptions")}
                    />
                </Col>
                <Col md={2}>
                    <Dropdown
                        name={"status"}
                        label={"Κατάσταση Συσκευής"}
                        options={statusOptions}
                        multiSelect={true}
                        defaultValue={requestData?.status}
                        onChange={(e) => handleOnChange(e, "dropdown", "status")}
                    />
                </Col>
                <Col md={2}>
                    <Dropdown
                        name={"contractStatus"}
                        label={"Κατάσταση Συμβολαίου"}
                        options={contractStatusOptions}
                        multiSelect={true}
                        defaultValue={requestData?.contractStatus}
                        onChange={(e) => handleOnChange(e, "dropdown", "contractStatus")}
                    />
                </Col>
                <Col md={2}>
                    <Dropdown
                        name={"subscriptionStatus"}
                        label={"Κατάσταση Συνδρομής"}
                        options={subscriptionStatusOptions}
                        multiSelect={true}
                        defaultValue={requestData?.subscriptionStatus}
                        onChange={(e) => handleOnChange(e, "dropdown", "subscriptionStatus")}
                    />
                </Col>
                <Col md={2}>
                    <Dropdown
                        name={"configurationStatus"}
                        label={"Κατάσταση Παραμετροποίησης"}
                        options={configurationStatusOptions}
                        multiSelect={true}
                        defaultValue={requestData?.configurationStatus}
                        onChange={(e) => handleOnChange(e, "dropdown", "configurationStatus")}
                    />
                </Col>
            </Row>
            </Row>
            <Row>
                <Col md={6}>
                    {responseData?.totals?.length > 0 && responseData?.totals?.map((el, index) => {
                        const available = el?.available || 0;
                        const waitingStock = el?.waitingStock || 0;
                        if(Number(waitingStock) > 0) {
                            return (
                                <Alert key={`alert_${index}`} style={{padding: "0.2rem", marginBottom: "10px"}} variant={"danger"}>
                                    <CgDanger size={25} /> <span style={{fontWeight: 'bold'}}>
                                  {`ΠΡΟΣΟΧΗ! Έχετε ${waitingStock} παραγγελίες για την συσκευή ${el?.productName} χωρίς να έχετε διαθέσιμες συσκευές στην αποθήκη! ΠΡΟΧΩΡΉΣΤΕ ΆΜΕΣΑ σε νέα παραγγελία από τον προμηθευτή.`}
                                    <span style={{fontSize: "20px"}}>😱😱😱😱😱😱🆘🆘🆘🆘🆘🆘</span>
                               </span>
                                </Alert>
                            );
                        }
                        if(Number(available) <= 5) {
                            return (
                               <Alert key={`alert2_${index}`} style={{padding: "0.2rem", marginBottom: "10px"}} variant={"danger"}>
                                   <CgDanger size={25} /> <span style={{fontWeight: 'bold'}}>
                                  {`ΠΡΟΣΟΧΗ! Η διαθεσιμότητα συσκευών ${el?.productName} είναι στα ${available} κομμάτια! Παρακαλώ προχωρήστε άμεσα σε νέα παραγγελία από τον προμηθευτή.`}
                               <span style={{fontSize: "20px"}}>😱🆘</span>
                               </span>
                               </Alert>
                            );
                        }
                        return (<React.Fragment></React.Fragment>);
                        })}
                </Col>
                <Col md={6}>
                    <Button onClick={() => fetchReport()} className="btn btn-primary float-right" disabled={loading}>
                        {t('General.applyFilter')}
                        {loading && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                    </Button>
                    <Button onClick={() => syncPos()} className="btn btn-primary float-right mr-3" disabled={loading}>
                        Συγχρονισμός Συσκευών POS
                        {loading && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                    </Button>
                    <Button onClick={() => setInsertNewModal(true)} className="btn btn-primary float-right mr-3" disabled={loading}>
                        Εισαγωγή Συσκευών
                    </Button>
                </Col>
            </Row>
            {responseData.totalPages > 0 && (
                <React.Fragment>
                    <hr/>
                    <Col md={12}>
                        <div className="d-flex justify-content-end mb-2">
                            {(responseData.totalItems !== 0 && responseData.data?.length > 0) && (<div className={"mr-3 mt-2"}><i>Σύνολο Αποτελεσμάτων: {responseData.totalItems}</i></div>)}
                            <Button
                                size={"sm"}
                                className={"mr-1"}
                                onClick={() => toFirstPage()}
                                disabled={requestData.page === 1 || loading}
                            >
                                {t('SalesBalanceSheet.first')}
                            </Button>
                            <Button
                                size={"sm"}
                                className={"mr-1"}
                                onClick={() => toPreviousPage()}
                                disabled={requestData.page === 1 || loading}
                            >
                                {t('SalesBalanceSheet.previous')}
                            </Button>
                            <Badge style={{fontSize: "12px", lineHeight: "20px"}} className="mr-1"
                                   bg="primary">{t('SalesBalanceSheet.page')} {requestData.page} / {responseData.totalPages}</Badge>
                            <Button
                                size={"sm"}
                                className={"mr-1"}
                                onClick={() => toNextPage()}
                                disabled={requestData.page === responseData.totalPages || loading}
                            >
                                {t('SalesBalanceSheet.next')}
                            </Button>
                            <Button
                                size={"sm"}
                                className={"mr-1"}
                                onClick={() => toLastPage()}
                                disabled={requestData.page === responseData.totalPages || loading}
                            >
                                {t('SalesBalanceSheet.last')}
                            </Button>
                        </div>
                    </Col>
                </React.Fragment>
            )}
            {responseData?.data?.length > 0 && (
                <React.Fragment>
                    <Row style={{overflowX: "auto"}}>
                        <Col md={12}>
                            <table className={"simpleClassicTable clientMovementsReportTable mb-2"} style={{width: "100%", tableLayout: "auto", wordBreak: "normal"}}>
                                <colgroup>
                                    <col span={1} style={{width: "2%"}}></col>
                                    <col span={1} style={{width: "5%"}}></col>
                                    <col span={1} style={{width: "5%"}}></col>
                                    <col span={1} style={{width: "5%"}}></col>
                                    <col span={1} style={{width: "15%"}}></col>
                                    <col span={1} style={{width: "5%"}}></col>
                                    <col span={1} style={{width: "5%"}}></col>
                                    <col span={1} style={{width: "6%"}}></col>
                                    <col span={1} style={{width: "13%"}}></col>
                                    <col span={1} style={{width: "7%"}}></col>
                                    <col span={1} style={{width: "7%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th style={{border: "1px solid gray"}}>A/A</th>
                                    <th style={{border: "1px solid gray"}}>Σειριακός Αριθμός</th>
                                    <th style={{border: "1px solid gray"}}>Θέση Αποθήκης</th>
                                    <th style={{border: "1px solid gray"}}>Ημερομηνία Εισαγωγής</th>
                                    <th style={{border: "1px solid gray"}}>Πελάτης</th>
                                    <th style={{border: "1px solid gray"}}>Συσκευή</th>
                                    <th style={{border: "1px solid gray"}}>Κατάσταση</th>
                                    <th style={{border: "1px solid gray"}}>Κατάσταση Συμβολαίου</th>
                                    <th style={{border: "1px solid gray"}}>Κατάσταση Παραμετροποίησης</th>
                                    <th style={{border: "1px solid gray"}}>Ημερομηνία Αγοράς</th>
                                    <th style={{border: "1px solid gray"}}>Ημερομηνία Αποστολής</th>
                                    <th style={{border: "1px solid gray"}}>Κατάσταση Αποστολής</th>
                                </tr>
                                </thead>
                                <tbody>
                                {responseData?.data?.map((row, idx) => (
                                    <tr key={`classTable-${idx}`} style={{cursor: "pointer", height: "45px", backgroundColor: statusOptions.find((el) => el.value === row["status"])?.color}} onClick={() => {
                                        const selection = window.getSelection();
                                        if (selection && selection.toString().length > 0) return;
                                        dispatch(setSelectedPrimerPos(row));
                                    }}>
                                        <td style={{border: "1px solid gray"}}>{row["no"]}</td>
                                        <td style={{border: "1px solid gray"}}>{row["serialNumber"]}</td>
                                        <td style={{border: "1px solid gray"}}>{row["warehousePosition"]}</td>
                                        <td style={{border: "1px solid gray"}}>{moment(row["created_at"]).format("DD/MM/YYYY")}</td>
                                        <td style={{border: "1px solid gray"}}>{row["clientVatNumber"] ? `${row["clientVatNumber"]} (${row["clientName"]})` : ""}</td>
                                        <td style={{border: "1px solid gray"}}>{row["productName"]}</td>
                                        <td style={{border: "1px solid gray"}}>{statusOptions.find((el) => el.value === row["status"])?.label}</td>
                                        <td style={{border: "1px solid gray"}}>{contractStatusOptions.find((el) => el.value === row["contractStatus"])?.label}</td>
                                        <td style={{border: "1px solid gray"}}>
                                            {(() => {
                                                if(row["configurationSteps"].length > 0) {
                                                if(row["configurationSteps"].every((el) => el.status === "completed")) {
                                                    return `Πλήρως Παραμετροποιημένο (${row["configurationSteps"].filter((el) => el.status === "completed")?.length} / ${row["configurationSteps"]?.length})`
                                                } else if(row["configurationSteps"].some((el) => el.status === "completed")) {
                                                    return `Μερικώς Παραμετροποιημένο (${row["configurationSteps"].filter((el) => el.status === "completed")?.length} / ${row["configurationSteps"]?.length})`
                                                } else {
                                                    return `Μη Παραμετροποιημένο (${row["configurationSteps"].filter((el) => el.status === "completed")?.length} / ${row["configurationSteps"]?.length})`
                                                }
                                            } else {
                                                    return "";
                                                }
                                            })()}
                                        </td>
                                        <td style={{border: "1px solid gray"}}>{row["paidDate"] ? moment(row["paidDate"]).format("DD/MM/YYYY HH:mm") : ""}</td>
                                        <td style={{border: "1px solid gray"}}>{row["shippingDate"] ? moment(row["shippingDate"]).format("DD/MM/YYYY") : ""}</td>
                                        <td style={{border: "1px solid gray"}}>{(!isEmpty(row["acsTrackingDetails"]) && row["acsTrackingDetails"]?.length > 0)? row["acsTrackingDetails"].slice().sort((a, b) => new Date(b.checkpoint_date_time) - new Date(a.checkpoint_date_time))[0]?.checkpoint_action : ""}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    <Row className={"mb-3"}>
                        <Col md={'auto'}>
                            <BootstrapDropdown className="mb-3 mt-3">
                                <BootstrapDropdown.Toggle variant="primary" id="dropdown-basic">
                                    Αποθήκευση αποτελεσμάτων
                                </BootstrapDropdown.Toggle>
                                <BootstrapDropdown.Menu>
                                    <BootstrapDropdown.Item onClick={() => handlePDFExport()}>
                                        Αποθήκευση ως PDF
                                    </BootstrapDropdown.Item>
                                    <BootstrapDropdown.Item onClick={() => handleExcelExport()}>
                                        Αποθήκευση ως XLSX
                                    </BootstrapDropdown.Item>
                                </BootstrapDropdown.Menu>
                            </BootstrapDropdown>
                        </Col>
                        <Col md={'auto'} className="ms-auto">
                            <p className="text-muted mb-1"><i>Σύνολα ανά κατάσταση συσκευής:</i></p>
                            <Table bordered={true}>
                                <tbody>
                                <tr key={"headerDevices"} style={{textAlign: "center"}}>
                                    <td><strong>Συσκευή</strong></td>
                                    {statusOptions.map((el) => (
                                        <td key={`header-${el.value}`}><strong>{el?.label}</strong></td>
                                    ))}
                                    <td><strong>Σύνολα</strong></td>
                                </tr>
                                {responseData?.totals?.length > 0 && responseData?.totals?.map((row, index) => (
                                    <tr key={index} style={{ textAlign: "center" }}>
                                        <td><strong>{row?.productName}</strong></td>
                                        {statusOptions.map((el) => (
                                            <td key={`header-${el.value}`}><strong>{!isEmpty(row[el.value]) ? row[el.value] : 0}</strong></td>
                                        ))}
                                        <td><strong>{row?.total}</strong></td>
                                    </tr>
                                ))}
                                <tr key={"totalsDevices"} style={{ textAlign: "center", background: "#f5f5f5" }}>
                                    <td><strong>Σύνολα</strong></td>
                                    {statusOptions.map((el) => {
                                        const totalForStatus = responseData.totals.reduce((sum, row) => sum + (row[el.value] || 0), 0);
                                        return (
                                            <td key={`total-${el.value}`}>
                                                <strong>{totalForStatus}</strong>
                                            </td>
                                        );
                                    })}
                                    <td>
                                        <strong>
                                            {responseData.totals.reduce((sum, row) => sum + (row.total || 0), 0)}
                                        </strong>
                                    </td>
                                </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </React.Fragment>
            )}

            <PrimerPosModal />
            <InsertPosModal show={insertNewModal} setShow={setInsertNewModal} fetchReport={() => fetchReport(false)} />
        </React.Fragment>
    )
}

export default PrimerPosReport;